import { redirect } from "@tanstack/react-router";

/**
 * Permanent redirect for legacy URLs, ported from the react-router
 * `<Navigate replace />` route entries. Server-side this issues a real
 * 301 (better for SEO than the old client-side redirect); client-side
 * the router follows the href.
 */
export function legacyRedirect(href: string): never {
  throw redirect({ href, statusCode: 301 });
}
